export function createDeveloperGaProduct(id: number, name: string) {
  return { dealType: 'sale', objectType: 'Builder', brand: `${id}/developer`, name };
}
